// extracted by mini-css-extract-plugin
export default {"MainCont":"Chilling_MainCont__jd9HE","LeftCont":"Chilling_LeftCont__erFCp","RightCont":"Chilling_RightCont__hrmwk"};